import React, {useCallback, useContext, useMemo, useRef, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import accountIconNew from '../../../../svg/account-icon-new.svg'
import {openMobileMenu} from '../../actions/mobileMenu'
import {logout} from '../../actions/user'
import {getAccountManagementLinks} from '../../config/headerConfig'
import {CartContext} from '../../contexts/CartContext'
import {useClickAway} from '../../hooks/useClickAway'
import {windowIsPhone} from '../../store/pane'
import * as track from '../../track/track'
import {getLoginRedirectPath} from '../Onboarding/standaloneUtils'
import Svg from '../Svg'
import styles from './AccountCta.module.scss'
import {NavItemDropdown} from './NavItemDropdown'

interface IAccountCtaProps {
  isLoggedIn: boolean
}

export const AccountCta: React.FC<IAccountCtaProps> = ({isLoggedIn}) => {
  const isMobile = useSelector(windowIsPhone)
  const [isExpanded, setIsExpanded] = useState(false)
  const {deactivateCart} = useContext(CartContext)
  const dispatch = useDispatch()
  const ref = useRef(null)

  const onLogoutClick = useCallback(() => {
    deactivateCart()
    dispatch(logout())
  }, [deactivateCart, dispatch])

  const links = useMemo(() => getAccountManagementLinks({onLogout: onLogoutClick}), [onLogoutClick])

  useClickAway(ref, () => {
    setIsExpanded(false)
  })

  const handleLoggedOutClick = () => {
    track.headerLoginLinkClicked()
    window.location.href = getLoginRedirectPath()
  }

  const handleLoggedInClick = () => {
    if (isMobile) {
      dispatch(openMobileMenu())
    } else {
      setIsExpanded((prev) => !prev)
    }
  }

  return (
    <div className={styles.root}>
      <button
        type="button"
        onClick={isLoggedIn ? handleLoggedInClick : handleLoggedOutClick}
        className={styles.accountCta}
        ref={ref}
      >
        <Svg className={styles.accountIcon} src={accountIconNew} />
      </button>
      <div className={styles.navContainer}>
        <NavItemDropdown items={links} isExpanded={isExpanded} />
      </div>
    </div>
  )
}
